import * as React from 'react';

import { Root, Placeholder } from './styled';


export type FetchingPlaceholderProps = {
	appearance: 'text';
	isFetching: boolean;
};

class FetchingPlaceholder extends React.PureComponent<FetchingPlaceholderProps> {
	static displayName = 'FetchingPlaceholder';

	render() {
		const { isFetching, children } = this.props;

		return (
			<Root>
				{
					isFetching
					?	<Placeholder />
					: children
				}
			</Root>
		);
	}
}

export default FetchingPlaceholder;
